import { matchPath } from 'react-router';
import { ImportPublicTemplateParsedValue } from '~/components/Signup/types/signup.types';
import {
    IMPORT_PUBLIC_TEMPLATE_STORAGE_KEY,
    SHOULD_REDIRECT_TO_HOME_STORAGE_KEY
} from '~/components/Templates/constants/storage-keys';
import {
    PUBLIC_TEMPLATE_MODE_FLOW_ROUTE,
    PUBLIC_TEMPLATE_ROUTE_NEW_ROUTE
} from '~/constants/client-experience.consts';
import { addObjectParamToUrl } from '~/utils/url.utils';

export const isPublicTemplateViewMode = () => {
    const { pathname } = window.location;
    return !!matchPath(pathname, [
        PUBLIC_TEMPLATE_MODE_FLOW_ROUTE,
        PUBLIC_TEMPLATE_ROUTE_NEW_ROUTE
    ]);
};

export const getImportTemplateParamsAndDeleteStorageValue = (
    additionalParams: Record<string, any> = {}
) => {
    const _publicTemplate = sessionStorage.getItem(
        IMPORT_PUBLIC_TEMPLATE_STORAGE_KEY
    );
    sessionStorage.removeItem(SHOULD_REDIRECT_TO_HOME_STORAGE_KEY);
    if (!_publicTemplate) {
        return null;
    }
    const publicTemplate = JSON.parse(
        _publicTemplate
    ) as ImportPublicTemplateParsedValue;
    const params = {
        noModalOnLoad: '1',
        importTemplateSuccess: '1',
        isGalleryTemplate: publicTemplate?.isGalleryTemplate,
        isPriced: !!publicTemplate?.templateRedeemCode && '1',
        action: 'edit',
        flow_id: publicTemplate.importedTemplateId,
        templateRedeemCode: publicTemplate.templateRedeemCode,
        ...additionalParams
    };

    sessionStorage.removeItem(IMPORT_PUBLIC_TEMPLATE_STORAGE_KEY);

    return params;
};

export const getPublicTemplateRedirectUrl = ({
    importedTemplateId,
    shouldRedirectToHome
}: { importedTemplateId?: string; shouldRedirectToHome?: boolean } = {}) => {
    const importTemplateParams = getImportTemplateParamsAndDeleteStorageValue();
    const _importedTemplateId =
        importTemplateParams?.flow_id || importedTemplateId;
    const editTemplateUrl = `${window.location.origin}/app/flow/${_importedTemplateId}/edit`;
    const params = {
        noModalOnLoad: '1',
        importTemplateSuccess: '1',
        isGalleryTemplate: importTemplateParams.isGalleryTemplate,
        isPriced: !!importTemplateParams.templateRedeemCode && '1',
        shouldRedirectToHome
    };

    const newUrl = addObjectParamToUrl({
        params,
        url: editTemplateUrl
    });

    return newUrl.toString();
};
